import { BACKEND_URL } from "@/lib/backend";
import axios from "axios";

const BASE = BACKEND_URL;
export const API = `${BASE}/api`;
export const mediaUrl = (id) => (id ? `${API}/media/${id}` : null);
// T12.a responsive variants: WebP (default) or JPEG at 160/320/640/1024 px
export const mediaVariant = (id, w, fmt) => (id ? `${API}/media/${id}?w=${w}${fmt ? `&fmt=${fmt}` : ""}` : null);
export const mediaSrcSet = (id, fmt, widths = [160, 320, 640, 1024]) => (id ? widths.map((w) => `${mediaVariant(id, w, fmt)} ${w}w`).join(", ") : undefined);

const client = axios.create({ baseURL: API });

// T12.a tiny client cache: in-flight dedupe + short TTL, so back/forward and hover-prefetch never refetch.
const TTL_MS = 60000;
const cache = new Map();
const cachedGet = (url, params) => {
  const key = url + "?" + new URLSearchParams(params || {}).toString();
  const hit = cache.get(key);
  if (hit && Date.now() - hit.at < TTL_MS) return hit.p;
  const p = client.get(url, { params }).then((r) => r.data);
  cache.set(key, { at: Date.now(), p });
  p.catch(() => cache.delete(key));
  if (cache.size > 200) cache.delete(cache.keys().next().value);
  return p;
};

export const getHome = () => cachedGet("/catalogue/home");
export const getHomeBundle = () => cachedGet("/catalogue/home-bundle");
export const getClearance = (params) => cachedGet("/catalogue/ex-demo-clearance", params);  // T48
export const getHomeBelow = () => cachedGet("/catalogue/home-bundle/below");
// T63: the countdown's server-clock offset is fixed once, when the config arrives (a cached reply keeps its original offset)
const stampCd = (c) => { const cd = c?.hero?.countdown; if (cd?.now && cd.offset == null) cd.offset = Date.parse(cd.now) - Date.now(); return c; };
const HOME_CFG = "/storefront/home-config";
export const getHomeConfig = (fresh = false) => { if (fresh) cache.delete(`${HOME_CFG}?`); return cachedGet(HOME_CFG).then(stampCd); };  // T54
export const getFooter = () => cachedGet("/storefront/footer");  // T63
export const getMegaMenu = () => cachedGet("/storefront/mega-menu");
export const getCategories = () => cachedGet("/catalogue/categories");
export const getBrands = () => cachedGet("/catalogue/brands");
export const getCategory = (slug, params) => cachedGet(`/catalogue/category/${slug}`, params);
export const getBrand = (slug, params) => cachedGet(`/catalogue/brand/${slug}`, params);
export const getBrandsIndex = () => cachedGet("/catalogue/brands-index");  // T55
export const getProduct = (slug) => cachedGet(`/catalogue/product/${slug}`);
export const prefetchProduct = (slug) => { getProduct(slug).catch(() => {}); };
export const getCatalogueStatus = () => cachedGet("/catalogue/status");
export const searchCatalogue = (params) => cachedGet("/catalogue/search", params);
export const compareProducts = (slugs) => client.get("/catalogue/compare", { params: { slugs: slugs.join(",") } }).then((r) => r.data);

export default client;
